import { render, staticRenderFns } from "./addAlipay.vue?vue&type=template&id=37fa8ab6&scoped=true&"
import script from "./addAlipay.vue?vue&type=script&lang=js&"
export * from "./addAlipay.vue?vue&type=script&lang=js&"
import style0 from "./addAlipay.vue?vue&type=style&index=0&id=37fa8ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa8ab6",
  null
  
)

export default component.exports